import { ClientAdminResourceType, Roles } from '@shared/types'

export const getFieldFilteredResults = (
  propertyName: string,
  resourceName: string
) => {
  if (resourceName === ClientAdminResourceType.USERS) {
    if (propertyName === 'companies') {
      return {}
    }

    if (propertyName === 'userRoles') {
      return {
        filteredResults: [
          Roles.ClientBasic,
          Roles.ClientAdministrator,
          Roles.ClientEditor,
          Roles.Client,
        ],
        filterField: 'roleName',
      }
    }
  }

  return {}
}
